/* ----------------------------------------
    Imports
---------------------------------------- */

import { ApiService } from './ApiService';

/* ----------------------------------------
    API Service
---------------------------------------- */

export class FileService extends ApiService {

    /* ----------------------------------------
        Constructor
    ---------------------------------------- */

    protected constructor(store) {
        super('', store);
    }

    public async postFile(data: object = {}) {
        const formData = new FormData();
        const headers = {
            'Content-Type': 'multipart/form-data'
        };

        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        })
        
        return this.post(`/file/`, formData, headers);
    }

    public async getFile(id: string = '', owner: string = '', type: string = '') {
        return this.get(`/file/${ id }/${ owner }/${ type }`);
    }

    public async getFiles(id: string = '', owner: string = '') {
        return this.get(`/file-types/${ id }/${ owner }`);
    }

    public async downloadFile(id: string = '') {
        return this.custom({
            method: 'get',
            url: `/file/${ id }`,
            responseType: 'blob',
        });
    }

    public async deleteFile(id: string = '') {
        return this.delete(`/file/${ id }`);
    }
}